<template>
  <div id="app"
      :class="theme">
    <router-view/>
    <ticket-preview v-if="ticketPreviewShow"></ticket-preview>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  data() {
    return {
      theme: `theme-${this.$store.getters.companyTheme}`,
    };
  },
  computed: {
    ...mapGetters([
      'ticketPreviewShow',
    ]),
  },
};
</script>
